import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { SelectCombobox } from './components/SelectCombobox';
import { SelectMenu } from './components/SelectMenu';
import { SelectPopoverProvider } from './components/SelectPopover';
import { SingleSelectProvider, } from './SingleSelectProvider';
export const SingleSelect = forwardRef((props, ref) => {
    return (_jsx(SingleSelectProvider, { ...props, children: _jsxs(SelectPopoverProvider, { children: [_jsx(SelectCombobox, { ref: ref }), _jsx(SelectMenu, {})] }) }));
});
SingleSelect.displayName = 'SingleSelect';
